"use client";

import { useEffect, useState } from "react";
import _Lightbox, { SlideImage } from "yet-another-react-lightbox";
import { Zoom } from "yet-another-react-lightbox/plugins";

import "yet-another-react-lightbox/styles.css";

type LightboxProps = {
  slides: SlideImage[];
};

const stripUrlParams = (url: string): string => {
  try {
    return new URL(url).origin + new URL(url).pathname;
  } catch {
    return url.split("?")[0];
  }
};

const Lightbox = (props: LightboxProps) => {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      if (target.tagName.toLowerCase() === "img") {
        const imgSrcRaw = (target as HTMLImageElement).src;
        const imgSrc = stripUrlParams(imgSrcRaw);

        const index = props.slides.findIndex((slide) => slide.src === imgSrc);

        if (index !== -1) {
          setLightboxIndex(index);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [props.slides]);

  return (
    <_Lightbox
      open={lightboxIndex !== null}
      close={() => setLightboxIndex(null)}
      index={lightboxIndex ?? 0}
      slides={props.slides}
      plugins={[Zoom]}
    />
  );
};

export default Lightbox;
